export default __webpack_public_path__ + "static/media/Consecrated Mace.8a157ee2.jpg";